import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../App';

export default function Login() {
  const { login } = useAuthContext();
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
      navigate('/dashboard');
    } catch (err: any) {
      setError(err.response?.data?.error || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  const quickLogin = (role: 'originator' | 'reviewer') => {
    setEmail(role === 'originator' ? 'originator@genesis.com' : 'reviewer@genesis.com');
    setPassword('demo123');
  };

  return (
    <div className="min-h-screen bg-[#0F1117] flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        {/* Logo */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-[#2563EB] rounded-2xl mb-4">
            <span className="text-white text-2xl font-bold font-mono">GC</span>
          </div>
          <h1 className="text-2xl font-bold text-white">Genesis Capital</h1>
          <p className="text-gray-500 text-sm mt-1">Loan Origination System</p>
        </div>

        {/* Form */}
        <div className="bg-[#1A1D27] rounded-2xl p-8 border border-gray-800">
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-400 mb-1.5 uppercase tracking-wider">
                Email
              </label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                className="w-full bg-[#0F1117] border border-gray-700 rounded-lg px-3 py-2.5 text-white text-sm focus:outline-none focus:border-[#2563EB] focus:ring-1 focus:ring-[#2563EB]/50 transition-colors"
                placeholder="you@genesis.com"
                required
              />
            </div>

            <div>
              <label className="block text-xs font-medium text-gray-400 mb-1.5 uppercase tracking-wider">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="w-full bg-[#0F1117] border border-gray-700 rounded-lg px-3 py-2.5 text-white text-sm focus:outline-none focus:border-[#2563EB] focus:ring-1 focus:ring-[#2563EB]/50 transition-colors"
                placeholder="••••••••"
                required
              />
            </div>

            {error && (
              <div className="bg-[#EF4444]/10 border border-[#EF4444]/30 rounded-lg px-3 py-2 text-[#F87171] text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#2563EB] hover:bg-[#1D4ED8] disabled:bg-gray-700 disabled:text-gray-500 text-white font-semibold py-3 rounded-lg transition-colors text-sm mt-2"
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          {/* Demo quick login */}
          <div className="mt-6 pt-6 border-t border-gray-800">
            <p className="text-xs text-gray-600 text-center mb-3 uppercase tracking-wider">Demo Quick Login</p>
            <div className="grid grid-cols-2 gap-2">
              <button
                onClick={() => quickLogin('originator')}
                className="text-xs bg-[#10B981]/10 hover:bg-[#10B981]/20 border border-[#10B981]/30 text-[#34D399] rounded-lg py-2 px-3 transition-colors text-left"
              >
                <div className="font-medium">Sarah Chen</div>
                <div className="text-[#6EE7B7] opacity-75">Loan Originator</div>
              </button>
              <button
                onClick={() => quickLogin('reviewer')}
                className="text-xs bg-[#2563EB]/10 hover:bg-[#2563EB]/20 border border-[#2563EB]/30 text-[#60A5FA] rounded-lg py-2 px-3 transition-colors text-left"
              >
                <div className="font-medium">Mike Torres</div>
                <div className="text-[#93C5FD] opacity-75">Loan Reviewer</div>
              </button>
            </div>
            <p className="text-xs text-gray-700 text-center mt-2">Password: demo123</p>
          </div>
        </div>
      </div>
    </div>
  );
}
